import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { TextInput as CropCircleTextInput } from '../../crop-circle/Components/TextInput/TextInput';
import { tokens } from '../../crop-circle/tokens';
import { DateRangeSelector, useFormContext } from '../../forms';
import { AlertOptionsOld } from './alertOptions-old';
import { AlertInputs } from './types';

// TODO: Crop Circle Redesign: Remove after feature is fully rolled out
export const AlertOptions = () => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  if (!isCropCircleRedesignEnabled) {
    return <AlertOptionsOld />;
  }
  return <AlertOptionsBase />;
};

const AlertOptionsBase = () => {
  const { t } = useTranslation();
  const { setValue, control, getValues } = useFormContext();

  const alertName = getValues(AlertInputs.alertLabel);
  const alertNamePlaceholder = getValues(AlertInputs.alertLabelPlaceholder);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t('alerts.customLabelTitle')}</Text>
      <CropCircleTextInput
        value={alertName}
        onChangeText={(text) =>
          setValue(AlertInputs.alertLabel, text, { shouldDirty: false })
        }
        placeholder={alertNamePlaceholder || t('common.optional')}
        textArea={true}
        numberOfLines={2}
        autoExpand={true}
        backgroundColor={tokens.colors.neutral[200]}
        hideBorder={true}
        style={styles.textInputWrapper}
      />

      <Text style={styles.title}>{t('alerts.blackoutDates')}</Text>
      <DateRangeSelector
        control={control}
        setValue={setValue}
        maxYears={5}
        minDate={moment().format('YYYY-MM-DD')}
        styleContainer={styles.dateRangeContainer}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    minHeight: 0,
  },
  title: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    color: tokens.colors.brand.black,
    marginBottom: tokens.spacing.sm,
  },
  textInputWrapper: {
    marginBottom: tokens.spacing.lg,
  },
  dateRangeContainer: {
    flexDirection: 'row',
    gap: tokens.spacing.sm,
  },
});
